import { Visibility } from '@mui/icons-material'
import { GridActionCellItem } from '../../components/common/kc-table/components'
import dayjs from 'dayjs'

export const getColumns = ({ onView }) => {
  const columns = [
    {
      field: 'orderNumber',
      headerName: 'Order Number',
      minWidth: 80,
      flex: 1,
    },

    {
      field: 'kproTeamId',
      headerName: 'Facility Name',
      minWidth: 200,
      flex: 1,
    },
    {
      field: 'createdAt',
      headerName: 'Created At',
      minWidth: 200,
      flex: 1,
      type: 'dateTime',
      valueFormatter: ({ value }) => {
        return dayjs(value).format('lll')
      },
      sortComparator: (v1, v2) => {
        return dayjs(v1).isAfter(dayjs(v2)) ? 1 : -1
      }
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      minWidth: 120,
      cellClassName: 'actions',
      getActions: ({ id }) => {
        return [
          <GridActionCellItem
            icon={<Visibility />}
            label="View Logs"
            className="textPrimary"
            onClick={onView(id)}
            color="inherit"
          />,
        ]
      },
    },
  ]
  return columns
}
